import { render, staticRenderFns } from "./BettingAdd.vue?vue&type=template&id=0c99a9ec&scoped=true"
import script from "./BettingAdd.vue?vue&type=script&lang=js"
export * from "./BettingAdd.vue?vue&type=script&lang=js"
import style0 from "./BettingAdd.vue?vue&type=style&index=0&id=0c99a9ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c99a9ec",
  null
  
)

export default component.exports